export class FullScreenService {
    constructor() {
        this.document = document;
        this.exitFullScreenFunction = this.getDefaultExitFullScreenFunction();
    }
    /**
     * Get exit fullscreen function based on browser
     *
     * @returns function for exiting fullscreen mode
     */
    getDefaultExitFullScreenFunction() {
        return this.document.exitFullscreen ||
            this.document.msExitFullscreen ||
            this.document.mozCancelFullScreen ||
            this.document.webkitExitFullscreen;
    }
    /**
     * Get element's request fullscreen function based on browser
     *
     * @param element - DOM element
     * @returns function for requesting fullscreen mode
     */
    getElementRequestFullScreenFunction(element) {
        return element.requestFullscreen ||
            element.msRequestFullscreen ||
            element.mozRequestFullScreen ||
            element.webkitRequestFullscreen;
    }
    /**
     * Get fullscreen event name based on browser
     *
     * @returns string of fullscreen event name
     */
    getOnFullScreenChangeEvent() {
        return this.document.fullscreenEnabled ? 'fullscreenchange' :
            this.document.msFullscreenEnabled ? 'msfullscreenchange' :
                this.document.mozFullScreenEnabled ? 'mozfullscreenchange' :
                    this.document.webkitFullscreenEnabled ? 'webkitfullscreenchange' :
                        undefined;
    }
    /**
     * Adds default fullscreen event listener to add and remove 'fullscreen' class from <html> and toggle isOnFullScreen boolean
     */
    addFullScreenDefaultListener() {
        const fullScreenEventName = this.getOnFullScreenChangeEvent();
        if (fullScreenEventName) {
            window.addEventListener(fullScreenEventName, (_) => {
                if (this.onFullScreen()) {
                    document.documentElement.classList.add('fullscreen');
                    this.isOnFullScreen = true;
                }
                else {
                    document.documentElement.classList.remove('fullscreen');
                    this.isOnFullScreen = false;
                }
            }, { passive: true });
        }
    }
    /**
     * Adds a custom fullscreen event listener
     *
     * @param customFunction - event listener function
     */
    addFullScreenCustomListener(customFunction) {
        const fullScreenEventName = this.getOnFullScreenChangeEvent();
        if (fullScreenEventName) {
            window.addEventListener(fullScreenEventName, customFunction, { passive: true });
        }
    }
    /**
     * Removes a custom fullscreen event listener
     *
     * @param customFunction - event listener function
     */
    removeFullScreenCustomListener(customFunction) {
        const fullScreenEventName = this.getOnFullScreenChangeEvent();
        if (fullScreenEventName) {
            window.addEventListener(fullScreenEventName, customFunction, { passive: true });
        }
    }
    /**
     * Calls browser's exit fullscreen function
     *
     * @returns if document has an element on fullscreen mode
     */
    onFullScreen() {
        return this.document.fullscreenElement != undefined ||
            this.document.webkitFullscreenElement != undefined ||
            this.document.mozFullScreenElement != undefined ||
            this.document.msFullscreenElement != undefined;
    }
    /**
     * Toggles fullscreen mode, based on the current isOnFullScreen value
     *
     * @param element - DOM Element to toggle fullscreen
     */
    toggleFullScreen(element) {
        if (this.onFullScreen()) {
            this.exitFullScreen();
        }
        else {
            this.requestFullScreen(element);
        }
    }
    /**
     * Calls browser window or element's request fullscreen function
     *
     * @param element - DOM Element to enter fullscreen
     */
    requestFullScreen(element) {
        const elementRequestFullScreenFunction = this.getElementRequestFullScreenFunction(element);
        elementRequestFullScreenFunction.call(element);
    }
    /**
     * Calls browser window's exit fullscreen function
     */
    exitFullScreen() {
        this.exitFullScreenFunction.call(this.document);
    }
}
